export default __webpack_public_path__ + "static/media/Twelve.5561d14a.svg";